import { WalletConnectIcon } from '@/components/icons/WalletConnectIcon';
import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

type WalletConnectValueSourceIndicatorProps = {
  onClear: () => void;
};

/**
 * Shows WalletConnect source attribution for imported values with clear action.
 */
export function WalletConnectValueSourceIndicator({
  onClear,
}: WalletConnectValueSourceIndicatorProps): React.ReactElement {
  return (
    <div className="relative flex items-center gap-[5px] rounded-[70px] border border-zinc-100 bg-white pl-[10px] pr-[22px] py-[5px]">
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <div className="flex items-center gap-[5px]">
              <WalletConnectIcon className="h-[6px] w-[10px] shrink-0" />
              <span className="text-[10px] font-medium text-black leading-none">
                WalletConnect
              </span>
            </div>
          </TooltipTrigger>
          <TooltipContent>
            This value was populated by WalletConnect
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              type="button"
              variant="ghost"
              size="icon"
              onClick={onClear}
              aria-label="Clear value"
              className="absolute right-[5px] !h-[11px] !w-[11px] top-1/2 -translate-y-1/2 rounded-[58px] p-[2px] hover:bg-zinc-100"
            >
              <svg
                className="!h-[11px] !w-[11px]"
                viewBox="0 0 8 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <circle
                  cx="4"
                  cy="4"
                  r="3.3"
                  stroke="#52525B"
                  strokeWidth="0.8"
                />
                <path
                  d="M2.85 2.85L5.15 5.15"
                  stroke="#52525B"
                  strokeWidth="0.8"
                  strokeLinecap="round"
                />
                <path
                  d="M5.15 2.85L2.85 5.15"
                  stroke="#52525B"
                  strokeWidth="0.8"
                  strokeLinecap="round"
                />
              </svg>
            </Button>
          </TooltipTrigger>
          <TooltipContent>Clear value from WalletConnect</TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
}
